declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let ga4Initialized = false;

/** GA4スクリプトを動的に読み込み・初期化する（同意後に呼ぶ） */
export function initGA4(): void {
  if (ga4Initialized) return;
  ga4Initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8LZK183E3D';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer!.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', 'G-8LZK183E3D');
}

function gtag(...args: unknown[]) {
  window.gtag?.(...args);
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  gtag('event', name, params);
}

/** 申込フォーム送信成功 */
export function trackSignUp(plan: string, source: string, wantsDevice: boolean) {
  trackEvent('sign_up', { method: source, plan, wants_device: wantsDevice });
}

/** タブレット申込チェック */
export function trackGenerateLead(plan: string) {
  trackEvent('generate_lead', { plan });
}

/** プラン選択変更 */
export function trackSelectItem(plan: string) {
  trackEvent('select_item', { item_id: plan });
}

/** CTAボタンクリック */
export function trackCtaClick(buttonText: string, location: string) {
  trackEvent('cta_click', { button_text: buttonText, location });
}

/** セクション表示 */
export function trackScrollSection(sectionId: string) {
  trackEvent('scroll_section', { section_id: sectionId });
}
